import {
  BOOKING_TYPE_ENABLING_ROWS,
  type BookingTypeEnablingVisibilityContext,
  getBookingTypeEnabled
} from "../../Admin/CompanyCard/SettingDialog/company-card-booking-type-enabling.config";
import { BookingType } from "../../Booking-Form/typings/booking-inputs";
import type { MetaData, PlaceType, ZoneType } from "../../Login/typings/login.types";

const PLACE_QUICK_ACTION_BOOKING_TYPE_ORDER: readonly BookingType[] = [
  BookingType.WORKPLACE,
  BookingType.VEHICLE,
  BookingType.PARKINGPLACE,
  BookingType.ELECTRICCHARGINGSTATIONPLACE
];

const SECONDARY_PLACE_BOOKING_TYPE_ORDER: readonly BookingType[] = [
  BookingType.PARKINGPLACE,
  BookingType.ELECTRICCHARGINGSTATIONPLACE,
  BookingType.VEHICLE
];

const isPlaceTypeLicensed = (
  bookingType: BookingType,
  placeTypes: readonly PlaceType[],
  zoneTypes: readonly ZoneType[]
): boolean =>
  placeTypes.some(type => type.name === bookingType) ||
  zoneTypes.some(type => type.name === bookingType);

const resolveLicensedPlaceQuickAction = (
  bookingType: BookingType,
  meta: MetaData,
  placeTypes: readonly PlaceType[],
  zoneTypes: readonly ZoneType[],
  visibilityContext: BookingTypeEnablingVisibilityContext
): BookingType | null => {
  const row = BOOKING_TYPE_ENABLING_ROWS.find(config => config.bookingType === bookingType);

  if (!row?.bookingType) {
    return null;
  }

  if (!row.isVisible(visibilityContext)) {
    return null;
  }

  if (!getBookingTypeEnabled(meta, row.metaKey)) {
    return null;
  }

  if (!isPlaceTypeLicensed(bookingType, placeTypes, zoneTypes)) {
    return null;
  }

  return bookingType;
};

export function resolveDashboard2AvailablePlaceQuickActions(
  meta: MetaData,
  placeTypes: readonly PlaceType[],
  zoneTypes: readonly ZoneType[],
  visibilityContext: BookingTypeEnablingVisibilityContext
): BookingType[] {
  return PLACE_QUICK_ACTION_BOOKING_TYPE_ORDER.flatMap(bookingType => {
    const resolved = resolveLicensedPlaceQuickAction(
      bookingType,
      meta,
      placeTypes,
      zoneTypes,
      visibilityContext
    );

    return resolved ? [resolved] : [];
  });
}

export function resolveDashboard2PrimaryPlaceQuickAction(
  meta: MetaData,
  placeTypes: readonly PlaceType[],
  zoneTypes: readonly ZoneType[],
  visibilityContext: BookingTypeEnablingVisibilityContext
): BookingType | null {
  return resolveLicensedPlaceQuickAction(
    BookingType.WORKPLACE,
    meta,
    placeTypes,
    zoneTypes,
    visibilityContext
  );
}

export function resolveDashboard2SecondaryPlaceQuickAction(
  meta: MetaData,
  placeTypes: readonly PlaceType[],
  zoneTypes: readonly ZoneType[],
  visibilityContext: BookingTypeEnablingVisibilityContext
): BookingType | null {
  for (const bookingType of SECONDARY_PLACE_BOOKING_TYPE_ORDER) {
    const resolved = resolveLicensedPlaceQuickAction(
      bookingType,
      meta,
      placeTypes,
      zoneTypes,
      visibilityContext
    );

    if (resolved) {
      return resolved;
    }
  }

  return null;
}
